import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import ChangeCircleOutlinedIcon from '@mui/icons-material/ChangeCircleOutlined';
import DataUsageOutlinedIcon from '@mui/icons-material/DataUsageOutlined';
import SavingsOutlinedIcon from '@mui/icons-material/SavingsOutlined';
import CurrencyRupeeOutlinedIcon from '@mui/icons-material/CurrencyRupeeOutlined';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Skeleton } from '@mui/material';

export default function DashboardCards({ CSD }) {
  const leadExpenseDashboardCards = useSelector((state) => state.crd.leadExpenseDashboardCards.data ?? {});
  const leadExpenseDashboardCardsLoading = useSelector((state) => state.crd.leadExpenseDashboardCards.loading);

  const cards = useMemo(
    () => [
      {
        title: 'Highest Lead count',
        value: 'top_name',
        sub: 'top_count',
        bg: '#EDF4FF',
        accent: '#0B6CFF',
        icon: <TrendingUpIcon />,
      },
      {
        title: 'Total Lead count',
        value: 'total_leads',
        bg: '#F4F1FF',
        accent: '#8B5CF6',
        icon: <PeopleAltIcon />,
      },
      {
        title: 'Qualified Lead count',
        value: 'qualified_lead_count',
        bg: '#ECFDF5',
        accent: '#10B981',
        icon: <CheckCircleOutlinedIcon />,
      },
      {
        title: 'Converted',
        value: 'converted',
        bg: '#F0FDF4',
        accent: '#22C55E',
        icon: <ChangeCircleOutlinedIcon />,
      },

      ...(CSD
        ? [
            {
              title: 'LCR',
              value: 'lcr',
              bg: '#FFF7E6',
              accent: '#F97316',
              icon: <DataUsageOutlinedIcon />,
            },
          ]
        : [
            {
              title: 'ACR',
              value: 'acr',
              bg: '#FFF7E6',
              accent: '#F97316',
              icon: <DataUsageOutlinedIcon />,
            },

            {
              title: 'Total Cost',
              value: 'total_cost',
              bg: '#FFF1F2',
              accent: '#F43F5E',
              icon: <CurrencyRupeeOutlinedIcon />,
            },
            {
              title: 'Total Revenue',
              value: 'total_revenue',
              bg: '#EEF2FF',
              accent: '#4F46E5',
              icon: <SavingsOutlinedIcon />,
            },
          ]),
    ],
    [CSD],
  );
  return (
    <Grid container spacing={1}>
      {leadExpenseDashboardCardsLoading
        ? cards.map((_, i) => (
            <Grid item xs={6} md={3} lg={2} xl={1.5} key={i}>
              <Skeleton sx={{ height: 200, width: '100%' }} />
            </Grid>
          ))
        : cards.map(({ title, accent, bg, value, sub, icon }, i) => (
            <Grid item xs={6} md={3} lg={2} xl={1.5} key={i}>
              <Card
                sx={{
                  backgroundColor: bg,
                  borderRadius: 3,
                  p: 2.5,
                  height: '100%',
                  width: '100%',
                  boxShadow: 'none',
                }}
              >
                <Box
                  sx={{
                    width: 36,
                    height: 36,
                    borderRadius: 2,
                    backgroundColor: accent + '22',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    mb: 2,
                  }}
                >
                  {icon}
                </Box>
                <Typography variant="body2" color="text.secondary">
                  {title}
                </Typography>

                <Typography variant="h6" sx={{ fontWeight: 700, color: accent, mt: 0.5 }}>
                  {leadExpenseDashboardCards?.[value]}
                </Typography>

                {sub && (
                  <Typography variant="caption" color="text.secondary">
                    {leadExpenseDashboardCards?.[sub]} leads
                  </Typography>
                )}
              </Card>
            </Grid>
          ))}
    </Grid>
  );
}
